import ReactGA from "react-ga4";
import { getParticipantID, isLoggedIn } from "@10x/sso";

export function hasAnalytics() {
	return ( window.apiConfig2 && window.apiConfig2.googleAnalyticsId );
}

export function trackEventWithData( category: string, action: string, data?: object | string ) {
	if ( hasAnalytics() ) {
		let x: any = {};
		if ( typeof data === "string" ) {
			x.value = data;
		} else if ( data && typeof data == "object" ) {
			x = {
				...data,
			};
		}
		if ( isLoggedIn() ) {
			x.user = getParticipantID();
		}
		ReactGA.event(category, { category: category, action: action, label: JSON.stringify( x ) } );
	}
}

export function trackEvent( category: string, action: string, label?: string ) {
	trackEventWithData( category, action, label );
}

export function setTrackingUserId( userId?: string ) {
	hasAnalytics() && ReactGA.set( { userId: userId } );
}

export function setTrackingData( data: any ) {
	hasAnalytics() && ReactGA.set( data );
}
